import { createContext } from 'react'

/** Window-space bottom of the game navigation bar; zero outside a game. */
export const GameOverlayTopContext = createContext(0)

/** Leave room for the folder tab, with long content scrolling below the bar. */
export function floatingGamePanelBounds(height: number, safeTop: number, safeBottom: number, protectedTop: number) {
  // The 22px close tab starts 6px below the protected header / safe-area edge.
  const paddingTop = (protectedTop > 0 ? 0 : safeTop) + 22 + 6
  const paddingBottom = safeBottom + 16
  return {
    paddingTop,
    paddingBottom,
    maxHeight: Math.max(0, height - protectedTop - paddingTop - paddingBottom),
  }
}

/**
 * Bounds for an in-tree (non-Modal) backdrop over the game screen. The tint
 * starts at the very top so it covers the navigation bar too: on maps that
 * bleed into the bar, a backdrop starting at the bar's bottom left the map
 * under the transparent bar untinted. Content stays centred below the bar.
 */
export function inGameBackdropBounds(protectedTop: number, padding: number) {
  return { top: 0, paddingTop: Math.max(0, protectedTop) + padding }
}
